module.exports = __webpack_public_path__ + "static/media/coding.37646ca2.svg";